/* eslint-disable import/prefer-default-export */

import { useTranslation } from 'react-i18next';
import { addNotification } from 'lib/apollo/clientSchema/Notification';
import { CombinedGraphQLErrors } from '@apollo/client/errors';

export const useToast = () => {
  const { t } = useTranslation(['LAYOUT', 'STATIC']);

  const notificationFromErr = (error) => {
    if (!CombinedGraphQLErrors.is(error)) {
      return {
        autoClose: true,
        message: error.message,
        title: t('STATIC:SOMETHING_WENT_WRONG'),
        type: 'error',
      };
    }

    const { code, errorNumber } = error.errors?.[0]?.extensions || {};
    return {
      autoClose: true,
      errorCode: errorNumber,
      message: t([error.message, `ERRORS:${code}`], error.message),
      title: t([`ERRORS:${code}_TITLE`, 'ERRORS:SOMETHING_WENT_WRONG']),
      type: 'error',
    };
  };

  const toast = (notification) => {
    addNotification(notification);
  };

  const toastErr = (error) => {
    const notification = notificationFromErr(error);
    toast(notification);
  };

  return { toast, toastErr };
};
